"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreChargeStatusEnum = void 0;
/**
 * Статус начисления
 */
var BillingCoreChargeStatusEnum;
(function (BillingCoreChargeStatusEnum) {
  /**
   * Ожидает оплаты
   */
  BillingCoreChargeStatusEnum["PENDING"] = "PENDING";
  /**
   * Отменено.
   * Отмена возможна только для не оплаченных начислений,
   * для оплаченных возможен только возврат через API сделок.
   */
  BillingCoreChargeStatusEnum["CANCEL"] = "CANCEL";
  /**
   * Выполнен возврат
   */
  BillingCoreChargeStatusEnum["REFUND"] = "REFUND";
  /**
   * Оплачено
   */
  BillingCoreChargeStatusEnum["PAID"] = "PAID";
  /**
   * Не удалось произвести оплату
   */
  BillingCoreChargeStatusEnum["REJECT"] = "REJECT";
  /**
   * Начисление подтверждено (услуга успешно оказана или товар успешно передан)
   */
  BillingCoreChargeStatusEnum["CONFIRM"] = "CONFIRM";
  /**
   * Обжалуется
   */
  BillingCoreChargeStatusEnum["COMPLAINT"] = "COMPLAINT";
  /**
   * Произведён частичный возврат
   */
  BillingCoreChargeStatusEnum["PARTIAL_REFUND"] = "PARTIAL_REFUND";
})(BillingCoreChargeStatusEnum = exports.BillingCoreChargeStatusEnum || (exports.BillingCoreChargeStatusEnum = {}));
